(ns cloudpermit-commons.schemas.postal-code
  (:require [schema.core :as s]))

(def postal-code-schemas
  {:ca (s/pred (partial re-matches #"^[0-9A-Za-z]{3}\s[0-9A-Za-z]{3}$") "Postal code length must be 7 characters, e.g. A1A 1A1")
   :us (s/pred (partial re-matches #"\d{5}") "ZIP code must be 5 numbers")})
